import { useEffect } from "react";
import { COMPLAINT_SETUP } from "../../../api/allApi_List";
import AddComplaint from "../forms/AddComplaint";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import { ADD_COMPLAINT } from "../../../api/allApi_List";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";
import { prepareFormData } from "../../../functions/prepareFormData";

const AddComplaintPage = () => {
  const { data, isLoaded, error, getData } = useGetData();
  const { executePost, loading, formError, successResponse, setFormError } =
    usePostData();

  useEffect(() => {
    getData(COMPLAINT_SETUP);
  }, []);

  const sendData = async (formValues, reset) => {
    // send data into form data
    const formData = prepareFormData(formValues);
    //API calling
    executePost(formData, ADD_COMPLAINT, reset);
  };
  return (
    <MainPageLayout headerConfig={{ title: "Add Complaint" }}>
      {isLoaded && !error ? (
        <AddComplaint
          complaintSetup={data}
          loading={loading}
          sendData={sendData}
          successResponse={successResponse}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default AddComplaintPage;
